<template>
  <section class="bg-gray-50 border border-gray-100 border-solid mt-6 px-8 py-6 relative">
    <h3
      v-if="addingObs"
      class="font-semibold py-4 text-lg"
    >
      {{ $t('layout.observations.titleAdd') }}
    </h3>
    <h3
      v-if="editingObs"
      class="font-semibold py-4 text-lg"
    >
      {{ $t('layout.observations.titleUpdate') }}
    </h3>
    <textarea
      v-model="currentObsText"
      class="bg-white p-2 w-full"
      rows="4"
      :placeholder="$t('layout.observations.placeholder')"
    />
    <div class="layerCheckbox__overlay">
      <div class="checkboxWrapper flex items-center mt-4 px-4">
        <input
          id="ObservationGeneralCheckbox"
          :value="obsIsGeneral"
          class="leading-tight mr-2 sr-only"
          type="checkbox"
          @change="checkboxObservation"
        >
        <label
          class="block font-bold order-2 text-gray-400 text-sm"
          for="ObservationGeneralCheckbox"
        >{{ $t('layout.observations.isGeneral') }}</label>
      </div>
    </div>
    <div class="flex flex-wrap justify-end">
      <button
        class="btn btn__secondary"
        @click="reloadObs({ imageId })"
      >
        {{ $t('generic.cancel') }}
      </button>
      <button
        v-tooltip.top="toolTipConfirmObs"
        :disabled="(currentObs.observation === '' || currentObs.observation === null || (!obsIsGeneral && !currentObs.coord_x && !currentObs.coord_y && !currentObs.height && !currentObs.width))"
        class="btn btn__fitMode"
        @click="submitOne({ imageId })"
      >
        {{ addingObs ? $t('generic.add') : $t('generic.update') }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ObservationsEditItem',

  props: {
    imageId: {
      type: Number,
      default: () => null
    }
  },

  computed: {
    currentObsText: {
      get() {
        return this.currentObs.observation;
      },

      set(value) {
        this.setText(value);
      }
    },

    toolTipConfirmObs() {
      return (this.currentObs.observation === '' || this.currentObs.observation === null) && this.$t('pages.geolocalise.validation.fieldEmpty');
    },

    ...mapState('observations', ['loadedObs', 'currentObs', 'obsIsGeneral']),
    ...mapState('user', ['userInfo']),
    ...mapGetters('observations', ['editingObs', 'addingObs']),
    ...mapGetters('user', ['isLoggedIn'])
  },

  watch: {
    obsIsGeneral() {//check or uncheck the box according to value of obsIsGeneral
      var checkbox = document.getElementById('ObservationGeneralCheckbox');
      checkbox.checked = this.obsIsGeneral;
    }
  },

  methods: {
    checkboxObservation() {
      var checkbox = document.getElementById('ObservationGeneralCheckbox');
      this.toggleObsGeneral(checkbox.checked);
    },

    ...mapActions('observations', ['setText', 'reloadObs', 'deleteCurrentObs', 'submitOne', 'toggleObsGeneral'])
  }
};
</script>

<style lang="postcss">
.close-dialog{
  @apply absolute;
  right:12px;
  top:15px;
}

.layerCheckbox__overlay{

    & .checkboxWrapper label::before{
      background-color:rgb(220,220,220)
    }
}
</style>
